import React, { memo } from 'react'
import { Table, TableBody } from '@mui/material'
import {
  PopupListCell,
  AppTableRow,
  AppTableHead,
  TextCell,
} from 'src/components/tables'
import { getRoleTitle } from 'src/domain/role'
import { Member } from 'src/slices/services/api'
import style from './styles.module.scss'

export type MembersTableProps = {
  members: Member[]
  isSmallTable?: boolean
  orgCode?: string
} & React.StyledProps

const MembersTable: React.StyledFC<MembersTableProps> = memo(
  ({ members, isSmallTable, orgCode }: MembersTableProps) => {
    return (
      <Table>
        <AppTableHead
          columns={[
            { title: '利用ステータス' },
            { title: '権限' },
            { title: '氏名' },
            { title: 'メールアドレス' },
            { title: '担当店舗' },
          ]}
        />
        <TableBody>
          {members.map((member) => {
            const association = member.hasAllStoresPermission ? (
              <TextCell text="全ての店舗" width={100} />
            ) : (
              <PopupListCell
                items={
                  member.assignedStores?.map((assignedStore) => {
                    return {
                      code: assignedStore.code,
                      name: assignedStore?.name,
                    }
                  }) || []
                }
                suffix="店舗"
              />
            )
            return (
              <AppTableRow className={style.row} key={member.id}>
                <TextCell
                  className={
                    member.active ? style.statusActive : style.statusDeactive
                  }
                  text={member.active ? '利用中' : '利用停止'}
                  width={80}
                />
                <TextCell
                  text={getRoleTitle(orgCode ?? '', member.role)}
                  width={120}
                />
                <TextCell text={member.name} width={isSmallTable ? 100 : 240} />
                <TextCell
                  text={member.email}
                  width={isSmallTable ? 200 : 300}
                />
                {association}
              </AppTableRow>
            )
          })}
        </TableBody>
      </Table>
    )
  }
)

MembersTable.displayName = 'MembersTable'
export default MembersTable
